import React from 'react';

/* Lucide wrapper. The host page must load lucide UMD first:
   <script src="https://unpkg.com/lucide@0.544.0/dist/umd/lucide.min.js"></script>
   Names are Lucide PascalCase keys, e.g. "ArrowRight", "Sparkles", "BarChart3". */
export function Icon({name,size=20,stroke=1.75,color='currentColor',style,...rest}){
  const lib=typeof window!=='undefined'?(window.lucide&&window.lucide.icons):null;
  const node=lib?lib[name]:null;
  const children=node?node.map((entry,i)=>{
    const tag=Array.isArray(entry)?entry[0]:entry.tag;
    const attrs=Array.isArray(entry)?entry[1]:entry.attrs;
    return React.createElement(tag,{key:i,...attrs});
  }):null;
  return React.createElement('svg',{width:size,height:size,viewBox:'0 0 24 24',fill:'none',stroke:color,strokeWidth:stroke,strokeLinecap:'round',strokeLinejoin:'round','aria-hidden':true,style:{display:'block',flex:'0 0 auto',...style},...rest},children);
}
